// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var $dot$dot$slash$dot$dot$slash$dot$dot$slash = require("../../../");
var Css_Color = require("../../../../reason/common/Theme/Css_Color.bs.js");

var make = $dot$dot$slash$dot$dot$slash$dot$dot$slash.HighlightSection;

var JS = {
  make: make
};

function HighlightSection__Jsx3(props) {
  return React.createElement(make, {
              background: Css_Color.optToJs(props.background),
              textColor: Css_Color.optToJs(props.textColor),
              borderColor: Css_Color.optToJs(props.borderColor),
              children: props.children
            });
}

var make$1 = HighlightSection__Jsx3;

exports.JS = JS;
exports.make = make$1;
/* make Not a pure module */
